import React,{useRef, useState} from 'react';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import DeleteLeaveModal from './DeleteLeaveModal';
import { Tooltip } from '@mui/material';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import Grid3x3Icon from '@mui/icons-material/Grid3x3';
import StarIcon from '@mui/icons-material/Star';
import NavigationIcon from '@mui/icons-material/Navigation';

interface Props{
    color:string,
    backgroundColor:string
    text:string
    onClick?:()=>void,
    date?:any
    default?:string,
    dayType?:string,
    holidayType?:string,
    id?: string,
    handleClose?: () => void;
}

const TYPES = {
  public: false,
  bank: false,
  mercantile: false,
  company: false,
}

const Event=(props:Props)=>{
    const [showModal,setShowModal]=useState(false);
    const [holidayTypes, setHolidayTypes] = useState(TYPES);
    const mainDiv:any=useRef();
    
    const handleClose=()=>{
        setShowModal(false);
        props.handleClose();
    };

    const mobileCheck=()=> {
        if (window.innerWidth >= 768 ) {
            return false;
        } else {
            return true;
        }
    };

    React.useEffect(() => {
      const tempTypes = {...TYPES}
      Object.keys(TYPES).forEach((key: string) => {
        tempTypes[key] = props.holidayType?.toLowerCase().indexOf(key) > -1;
      }); 
      setHolidayTypes(tempTypes);
    }, [props.holidayType])

    return (<>
      <div
        ref={mainDiv}
        style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: props.backgroundColor,
          color: props.color,
          fontSize: mobileCheck() ? 15 : 9,
          textAlign: 'center',
          borderRadius: 3,
          maxWidth: mobileCheck() ? '760px' : '130px',
          fontWeight: 700,
          height: 22,
          marginTop: 3,
          marginLeft: window.innerWidth <= 960 ? 10 : 0,
          width: props.default ? 200 : 'auto'
        }}
      >
        <DeleteLeaveModal
          show={showModal}
          handleClose={handleClose}
          date={props.date}
          holidayType={props.holidayType}
          id={props.id}
        />
        {holidayTypes.bank && <Brightness1Icon sx={{ fontSize:'10px', color: '#0069E4'}} />}
        {holidayTypes.public && <Grid3x3Icon sx={{ fontSize:'10px' , color: '#F1C40F'}} />}
        {holidayTypes.mercantile && <StarIcon sx={{ fontSize:'10px', color: '#ED1C24'}} />}
        {holidayTypes.company && <NavigationIcon sx={{ fontSize:'10px', color: '#00B26A'}} />}

        <Tooltip title={props.text + " - " + props.dayType} placement="top" > 
        <span
          onClick={() => setShowModal(true)}
          style={{
            cursor: 'pointer',
            paddingRight: 4,
            paddingLeft: 4,
            width: '100%'
          }}
        >
          {props.text.length > 15 ? props.text.slice(0, 13) + '...' : props.text }
        </span>
        </Tooltip>
        {props.onClick && (
          <div style={{ marginLeft: 5, cursor: 'pointer' }}>
            <HighlightOffRoundedIcon
              onClick={() => {
                setShowModal(true);
              }}
              style={{ fontSize: 14, marginTop: 4 }}
            />
          </div>
        )}
      </div>
      </>
    );
}

export default Event;